import css from 'styled-jsx/css';

export default css`
  @media screen and (max-width: 768px) {
    .moduloTitle {
      .title {
        font-size: 32px;
        padding: 0px 20px;
      }
    }
  }
`;
